import {
  advertisementsAdminControllerList,
  type Advertisement,
  unwrapApiResponse,
} from "@cryptors/api-client";
import { useQuery } from "@tanstack/react-query";

const getAdvertisements = async (): Promise<Advertisement[]> => {
  const data = await unwrapApiResponse(
    advertisementsAdminControllerList<true>({
      query: { limit: 200 },
      throwOnError: true,
    }),
  );
  return Array.isArray(data) ? data : (data as { data: Advertisement[] }).data;
};

export const useGetAdvertisements = () => {
  return useQuery({
    initialData: [],
    queryKey: ["advertisements"],
    queryFn: () => getAdvertisements(),
  });
};
